import { render, staticRenderFns } from "./DaisoImage.vue?vue&type=template&id=a44321a8&"
import script from "./DaisoImage.vue?vue&type=script&lang=js&"
export * from "./DaisoImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports